import globalAxios from 'axios';
import { assertParamExists, DUMMY_BASE_URL, setApiKeyToObject, setSearchParams, toPathString, serializeDataIfNeeded, createRequestFunction } from '../common.js';
import { operationServerMap, BaseAPI, BASE_PATH } from '../base.js';

/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 *
 * Jellyfin API
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/.
 */
/**
 * SubtitleApi - axios parameter creator
 * @export
 */
const SubtitleApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Deletes an external subtitle file.
         * @param {string} itemId The item id.
         * @param {number} index The index of the subtitle file.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSubtitle: async (itemId, index, options = {}) => {
            // verify required parameter 'itemId' is not null or undefined
            assertParamExists('deleteSubtitle', 'itemId', itemId);
            // verify required parameter 'index' is not null or undefined
            assertParamExists('deleteSubtitle', 'index', index);
            const localVarPath = `/Videos/{itemId}/Subtitles/{index}`
                .replace(`{${"itemId"}}`, encodeURIComponent(String(itemId)))
                .replace(`{${"index"}}`, encodeURIComponent(String(index)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication CustomAuthentication required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Downloads a remote subtitle.
         * @param {string} itemId The item id.
         * @param {string} subtitleId The subtitle id.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadRemoteSubtitles: async (itemId, subtitleId, options = {}) => {
            // verify required parameter 'itemId' is not null or undefined
            assertParamExists('downloadRemoteSubtitles', 'itemId', itemId);
            // verify required parameter 'subtitleId' is not null or undefined
            assertParamExists('downloadRemoteSubtitles', 'subtitleId', subtitleId);
            const localVarPath = `/Items/{itemId}/RemoteSearch/Subtitles/{subtitleId}`
                .replace(`{${"itemId"}}`, encodeURIComponent(String(itemId)))
                .replace(`{${"subtitleId"}}`, encodeURIComponent(String(subtitleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication CustomAuthentication required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Gets a fallback font file.
         * @param {string} name The name of the fallback font file to get.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFallbackFont: async (name, options = {}) => {
            // verify required parameter 'name' is not null or undefined
            assertParamExists('getFallbackFont', 'name', name);
            const localVarPath = `/FallbackFont/Fonts/{name}`
                .replace(`{${"name"}}`, encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication CustomAuthentication required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Gets a list of available fallback font files.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFallbackFontList: async (options = {}) => {
            const localVarPath = `/FallbackFont/Fonts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication CustomAuthentication required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Gets the remote subtitles.
         * @param {string} subtitleId The item id.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRemoteSubtitles: async (subtitleId, options = {}) => {
            // verify required parameter 'subtitleId' is not null or undefined
            assertParamExists('getRemoteSubtitles', 'subtitleId', subtitleId);
            const localVarPath = `/Providers/Subtitles/Subtitles/{subtitleId}`
                .replace(`{${"subtitleId"}}`, encodeURIComponent(String(subtitleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication CustomAuthentication required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Gets subtitles in a specified format.
         * @param {string} routeItemId The (route) item id.
         * @param {string} routeMediaSourceId The (route) media source id.
         * @param {number} routeIndex The (route) subtitle stream index.
         * @param {string} routeFormat The (route) format of the returned subtitle.
         * @param {string} [itemId] The item id.
         * @param {string} [mediaSourceId] The media source id.
         * @param {number} [index] The subtitle stream index.
         * @param {string} [format] The format of the returned subtitle.
         * @param {number} [endPositionTicks] Optional. The end position of the subtitle in ticks.
         * @param {boolean} [copyTimestamps] Optional. Whether to copy the timestamps.
         * @param {boolean} [addVttTimeMap] Optional. Whether to add a VTT time map.
         * @param {number} [startPositionTicks] The start position of the subtitle in ticks.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubtitle: async (routeItemId, routeMediaSourceId, routeIndex, routeFormat, itemId, mediaSourceId, index, format, endPositionTicks, copyTimestamps, addVttTimeMap, startPositionTicks, options = {}) => {
            // verify required parameter 'routeItemId' is not null or undefined
            assertParamExists('getSubtitle', 'routeItemId', routeItemId);
            // verify required parameter 'routeMediaSourceId' is not null or undefined
            assertParamExists('getSubtitle', 'routeMediaSourceId', routeMediaSourceId);
            // verify required parameter 'routeIndex' is not null or undefined
            assertParamExists('getSubtitle', 'routeIndex', routeIndex);
            // verify required parameter 'routeFormat' is not null or undefined
            assertParamExists('getSubtitle', 'routeFormat', routeFormat);
            const localVarPath = `/Videos/{routeItemId}/{routeMediaSourceId}/Subtitles/{routeIndex}/Stream.{routeFormat}`
                .replace(`{${"routeItemId"}}`, encodeURIComponent(String(routeItemId)))
                .replace(`{${"routeMediaSourceId"}}`, encodeURIComponent(String(routeMediaSourceId)))
                .replace(`{${"routeIndex"}}`, encodeURIComponent(String(routeIndex)))
                .replace(`{${"routeFormat"}}`, encodeURIComponent(String(routeFormat)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (itemId !== undefined) {
                localVarQueryParameter['itemId'] = itemId;
            }
            if (mediaSourceId !== undefined) {
                localVarQueryParameter['mediaSourceId'] = mediaSourceId;
            }
            if (index !== undefined) {
                localVarQueryParameter['index'] = index;
            }
            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }
            if (endPositionTicks !== undefined) {
                localVarQueryParameter['endPositionTicks'] = endPositionTicks;
            }
            if (copyTimestamps !== undefined) {
                localVarQueryParameter['copyTimestamps'] = copyTimestamps;
            }
            if (addVttTimeMap !== undefined) {
                localVarQueryParameter['addVttTimeMap'] = addVttTimeMap;
            }
            if (startPositionTicks !== undefined) {
                localVarQueryParameter['startPositionTicks'] = startPositionTicks;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Gets an HLS subtitle playlist.
         * @param {string} itemId The item id.
         * @param {number} index The subtitle stream index.
         * @param {string} mediaSourceId The media source id.
         * @param {number} segmentLength The subtitle segment length.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubtitlePlaylist: async (itemId, index, mediaSourceId, segmentLength, options = {}) => {
            // verify required parameter 'itemId' is not null or undefined
            assertParamExists('getSubtitlePlaylist', 'itemId', itemId);
            // verify required parameter 'index' is not null or undefined
            assertParamExists('getSubtitlePlaylist', 'index', index);
            // verify required parameter 'mediaSourceId' is not null or undefined
            assertParamExists('getSubtitlePlaylist', 'mediaSourceId', mediaSourceId);
            // verify required parameter 'segmentLength' is not null or undefined
            assertParamExists('getSubtitlePlaylist', 'segmentLength', segmentLength);
            const localVarPath = `/Videos/{itemId}/{mediaSourceId}/Subtitles/{index}/subtitles.m3u8`
                .replace(`{${"itemId"}}`, encodeURIComponent(String(itemId)))
                .replace(`{${"index"}}`, encodeURIComponent(String(index)))
                .replace(`{${"mediaSourceId"}}`, encodeURIComponent(String(mediaSourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication CustomAuthentication required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (segmentLength !== undefined) {
                localVarQueryParameter['segmentLength'] = segmentLength;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Gets subtitles in a specified format.
         * @param {string} routeItemId The (route) item id.
         * @param {string} routeMediaSourceId The (route) media source id.
         * @param {number} routeIndex The (route) subtitle stream index.
         * @param {number} routeStartPositionTicks The (route) start position of the subtitle in ticks.
         * @param {string} routeFormat The (route) format of the returned subtitle.
         * @param {string} [itemId] The item id.
         * @param {string} [mediaSourceId] The media source id.
         * @param {number} [index] The subtitle stream index.
         * @param {number} [startPositionTicks] The start position of the subtitle in ticks.
         * @param {string} [format] The format of the returned subtitle.
         * @param {number} [endPositionTicks] Optional. The end position of the subtitle in ticks.
         * @param {boolean} [copyTimestamps] Optional. Whether to copy the timestamps.
         * @param {boolean} [addVttTimeMap] Optional. Whether to add a VTT time map.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubtitleWithTicks: async (routeItemId, routeMediaSourceId, routeIndex, routeStartPositionTicks, routeFormat, itemId, mediaSourceId, index, startPositionTicks, format, endPositionTicks, copyTimestamps, addVttTimeMap, options = {}) => {
            // verify required parameter 'routeItemId' is not null or undefined
            assertParamExists('getSubtitleWithTicks', 'routeItemId', routeItemId);
            // verify required parameter 'routeMediaSourceId' is not null or undefined
            assertParamExists('getSubtitleWithTicks', 'routeMediaSourceId', routeMediaSourceId);
            // verify required parameter 'routeIndex' is not null or undefined
            assertParamExists('getSubtitleWithTicks', 'routeIndex', routeIndex);
            // verify required parameter 'routeStartPositionTicks' is not null or undefined
            assertParamExists('getSubtitleWithTicks', 'routeStartPositionTicks', routeStartPositionTicks);
            // verify required parameter 'routeFormat' is not null or undefined
            assertParamExists('getSubtitleWithTicks', 'routeFormat', routeFormat);
            const localVarPath = `/Videos/{routeItemId}/{routeMediaSourceId}/Subtitles/{routeIndex}/{routeStartPositionTicks}/Stream.{routeFormat}`
                .replace(`{${"routeItemId"}}`, encodeURIComponent(String(routeItemId)))
                .replace(`{${"routeMediaSourceId"}}`, encodeURIComponent(String(routeMediaSourceId)))
                .replace(`{${"routeIndex"}}`, encodeURIComponent(String(routeIndex)))
                .replace(`{${"routeStartPositionTicks"}}`, encodeURIComponent(String(routeStartPositionTicks)))
                .replace(`{${"routeFormat"}}`, encodeURIComponent(String(routeFormat)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (itemId !== undefined) {
                localVarQueryParameter['itemId'] = itemId;
            }
            if (mediaSourceId !== undefined) {
                localVarQueryParameter['mediaSourceId'] = mediaSourceId;
            }
            if (index !== undefined) {
                localVarQueryParameter['index'] = index;
            }
            if (startPositionTicks !== undefined) {
                localVarQueryParameter['startPositionTicks'] = startPositionTicks;
            }
            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }
            if (endPositionTicks !== undefined) {
                localVarQueryParameter['endPositionTicks'] = endPositionTicks;
            }
            if (copyTimestamps !== undefined) {
                localVarQueryParameter['copyTimestamps'] = copyTimestamps;
            }
            if (addVttTimeMap !== undefined) {
                localVarQueryParameter['addVttTimeMap'] = addVttTimeMap;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Search remote subtitles.
         * @param {string} itemId The item id.
         * @param {string} language The language of the subtitles.
         * @param {boolean} [isPerfectMatch] Optional. Only show subtitles which are a perfect match.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchRemoteSubtitles: async (itemId, language, isPerfectMatch, options = {}) => {
            // verify required parameter 'itemId' is not null or undefined
            assertParamExists('searchRemoteSubtitles', 'itemId', itemId);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('searchRemoteSubtitles', 'language', language);
            const localVarPath = `/Items/{itemId}/RemoteSearch/Subtitles/{language}`
                .replace(`{${"itemId"}}`, encodeURIComponent(String(itemId)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication CustomAuthentication required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (isPerfectMatch !== undefined) {
                localVarQueryParameter['isPerfectMatch'] = isPerfectMatch;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Upload an external subtitle file.
         * @param {string} itemId The item the subtitle belongs to.
         * @param {UploadSubtitleDto} uploadSubtitleDto The request body.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadSubtitle: async (itemId, uploadSubtitleDto, options = {}) => {
            // verify required parameter 'itemId' is not null or undefined
            assertParamExists('uploadSubtitle', 'itemId', itemId);
            // verify required parameter 'uploadSubtitleDto' is not null or undefined
            assertParamExists('uploadSubtitle', 'uploadSubtitleDto', uploadSubtitleDto);
            const localVarPath = `/Videos/{itemId}/Subtitles`
                .replace(`{${"itemId"}}`, encodeURIComponent(String(itemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication CustomAuthentication required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(uploadSubtitleDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * SubtitleApi - functional programming interface
 * @export
 */
const SubtitleApiFp = function (configuration) {
    const localVarAxiosParamCreator = SubtitleApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Deletes an external subtitle file.
         * @param {string} itemId The item id.
         * @param {number} index The index of the subtitle file.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSubtitle(itemId, index, options) {
            var _a, _b, _c;
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSubtitle(itemId, index, options);
            const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
            const localVarOperationServerBasePath = (_c = (_b = operationServerMap['SubtitleApi.deleteSubtitle']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Downloads a remote subtitle.
         * @param {string} itemId The item id.
         * @param {string} subtitleId The subtitle id.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadRemoteSubtitles(itemId, subtitleId, options) {
            var _a, _b, _c;
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadRemoteSubtitles(itemId, subtitleId, options);
            const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
            const localVarOperationServerBasePath = (_c = (_b = operationServerMap['SubtitleApi.downloadRemoteSubtitles']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Gets a fallback font file.
         * @param {string} name The name of the fallback font file to get.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFallbackFont(name, options) {
            var _a, _b, _c;
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFallbackFont(name, options);
            const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
            const localVarOperationServerBasePath = (_c = (_b = operationServerMap['SubtitleApi.getFallbackFont']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Gets a list of available fallback font files.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFallbackFontList(options) {
            var _a, _b, _c;
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFallbackFontList(options);
            const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
            const localVarOperationServerBasePath = (_c = (_b = operationServerMap['SubtitleApi.getFallbackFontList']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Gets the remote subtitles.
         * @param {string} subtitleId The item id.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRemoteSubtitles(subtitleId, options) {
            var _a, _b, _c;
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRemoteSubtitles(subtitleId, options);
            const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
            const localVarOperationServerBasePath = (_c = (_b = operationServerMap['SubtitleApi.getRemoteSubtitles']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Gets subtitles in a specified format.
         * @param {string} routeItemId The (route) item id.
         * @param {string} routeMediaSourceId The (route) media source id.
         * @param {number} routeIndex The (route) subtitle stream index.
         * @param {string} routeFormat The (route) format of the returned subtitle.
         * @param {string} [itemId] The item id.
         * @param {string} [mediaSourceId] The media source id.
         * @param {number} [index] The subtitle stream index.
         * @param {string} [format] The format of the returned subtitle.
         * @param {number} [endPositionTicks] Optional. The end position of the subtitle in ticks.
         * @param {boolean} [copyTimestamps] Optional. Whether to copy the timestamps.
         * @param {boolean} [addVttTimeMap] Optional. Whether to add a VTT time map.
         * @param {number} [startPositionTicks] The start position of the subtitle in ticks.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSubtitle(routeItemId, routeMediaSourceId, routeIndex, routeFormat, itemId, mediaSourceId, index, format, endPositionTicks, copyTimestamps, addVttTimeMap, startPositionTicks, options) {
            var _a, _b, _c;
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSubtitle(routeItemId, routeMediaSourceId, routeIndex, routeFormat, itemId, mediaSourceId, index, format, endPositionTicks, copyTimestamps, addVttTimeMap, startPositionTicks, options);
            const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
            const localVarOperationServerBasePath = (_c = (_b = operationServerMap['SubtitleApi.getSubtitle']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Gets an HLS subtitle playlist.
         * @param {string} itemId The item id.
         * @param {number} index The subtitle stream index.
         * @param {string} mediaSourceId The media source id.
         * @param {number} segmentLength The subtitle segment length.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSubtitlePlaylist(itemId, index, mediaSourceId, segmentLength, options) {
            var _a, _b, _c;
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSubtitlePlaylist(itemId, index, mediaSourceId, segmentLength, options);
            const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
            const localVarOperationServerBasePath = (_c = (_b = operationServerMap['SubtitleApi.getSubtitlePlaylist']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Gets subtitles in a specified format.
         * @param {string} routeItemId The (route) item id.
         * @param {string} routeMediaSourceId The (route) media source id.
         * @param {number} routeIndex The (route) subtitle stream index.
         * @param {number} routeStartPositionTicks The (route) start position of the subtitle in ticks.
         * @param {string} routeFormat The (route) format of the returned subtitle.
         * @param {string} [itemId] The item id.
         * @param {string} [mediaSourceId] The media source id.
         * @param {number} [index] The subtitle stream index.
         * @param {number} [startPositionTicks] The start position of the subtitle in ticks.
         * @param {string} [format] The format of the returned subtitle.
         * @param {number} [endPositionTicks] Optional. The end position of the subtitle in ticks.
         * @param {boolean} [copyTimestamps] Optional. Whether to copy the timestamps.
         * @param {boolean} [addVttTimeMap] Optional. Whether to add a VTT time map.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSubtitleWithTicks(routeItemId, routeMediaSourceId, routeIndex, routeStartPositionTicks, routeFormat, itemId, mediaSourceId, index, startPositionTicks, format, endPositionTicks, copyTimestamps, addVttTimeMap, options) {
            var _a, _b, _c;
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSubtitleWithTicks(routeItemId, routeMediaSourceId, routeIndex, routeStartPositionTicks, routeFormat, itemId, mediaSourceId, index, startPositionTicks, format, endPositionTicks, copyTimestamps, addVttTimeMap, options);
            const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
            const localVarOperationServerBasePath = (_c = (_b = operationServerMap['SubtitleApi.getSubtitleWithTicks']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Search remote subtitles.
         * @param {string} itemId The item id.
         * @param {string} language The language of the subtitles.
         * @param {boolean} [isPerfectMatch] Optional. Only show subtitles which are a perfect match.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchRemoteSubtitles(itemId, language, isPerfectMatch, options) {
            var _a, _b, _c;
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchRemoteSubtitles(itemId, language, isPerfectMatch, options);
            const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
            const localVarOperationServerBasePath = (_c = (_b = operationServerMap['SubtitleApi.searchRemoteSubtitles']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Upload an external subtitle file.
         * @param {string} itemId The item the subtitle belongs to.
         * @param {UploadSubtitleDto} uploadSubtitleDto The request body.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadSubtitle(itemId, uploadSubtitleDto, options) {
            var _a, _b, _c;
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadSubtitle(itemId, uploadSubtitleDto, options);
            const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
            const localVarOperationServerBasePath = (_c = (_b = operationServerMap['SubtitleApi.uploadSubtitle']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * SubtitleApi - factory interface
 * @export
 */
const SubtitleApiFactory = function (configuration, basePath, axios) {
    const localVarFp = SubtitleApiFp(configuration);
    return {
        /**
         *
         * @summary Deletes an external subtitle file.
         * @param {SubtitleApiDeleteSubtitleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSubtitle(requestParameters, options) {
            return localVarFp.deleteSubtitle(requestParameters.itemId, requestParameters.index, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Downloads a remote subtitle.
         * @param {SubtitleApiDownloadRemoteSubtitlesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadRemoteSubtitles(requestParameters, options) {
            return localVarFp.downloadRemoteSubtitles(requestParameters.itemId, requestParameters.subtitleId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Gets a fallback font file.
         * @param {SubtitleApiGetFallbackFontRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFallbackFont(requestParameters, options) {
            return localVarFp.getFallbackFont(requestParameters.name, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Gets a list of available fallback font files.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFallbackFontList(options) {
            return localVarFp.getFallbackFontList(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Gets the remote subtitles.
         * @param {SubtitleApiGetRemoteSubtitlesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRemoteSubtitles(requestParameters, options) {
            return localVarFp.getRemoteSubtitles(requestParameters.subtitleId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Gets subtitles in a specified format.
         * @param {SubtitleApiGetSubtitleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubtitle(requestParameters, options) {
            return localVarFp.getSubtitle(requestParameters.routeItemId, requestParameters.routeMediaSourceId, requestParameters.routeIndex, requestParameters.routeFormat, requestParameters.itemId, requestParameters.mediaSourceId, requestParameters.index, requestParameters.format, requestParameters.endPositionTicks, requestParameters.copyTimestamps, requestParameters.addVttTimeMap, requestParameters.startPositionTicks, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Gets an HLS subtitle playlist.
         * @param {SubtitleApiGetSubtitlePlaylistRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubtitlePlaylist(requestParameters, options) {
            return localVarFp.getSubtitlePlaylist(requestParameters.itemId, requestParameters.index, requestParameters.mediaSourceId, requestParameters.segmentLength, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Gets subtitles in a specified format.
         * @param {SubtitleApiGetSubtitleWithTicksRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubtitleWithTicks(requestParameters, options) {
            return localVarFp.getSubtitleWithTicks(requestParameters.routeItemId, requestParameters.routeMediaSourceId, requestParameters.routeIndex, requestParameters.routeStartPositionTicks, requestParameters.routeFormat, requestParameters.itemId, requestParameters.mediaSourceId, requestParameters.index, requestParameters.startPositionTicks, requestParameters.format, requestParameters.endPositionTicks, requestParameters.copyTimestamps, requestParameters.addVttTimeMap, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Search remote subtitles.
         * @param {SubtitleApiSearchRemoteSubtitlesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchRemoteSubtitles(requestParameters, options) {
            return localVarFp.searchRemoteSubtitles(requestParameters.itemId, requestParameters.language, requestParameters.isPerfectMatch, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Upload an external subtitle file.
         * @param {SubtitleApiUploadSubtitleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadSubtitle(requestParameters, options) {
            return localVarFp.uploadSubtitle(requestParameters.itemId, requestParameters.uploadSubtitleDto, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * SubtitleApi - object-oriented interface
 * @export
 * @class SubtitleApi
 * @extends {BaseAPI}
 */
class SubtitleApi extends BaseAPI {
    /**
     *
     * @summary Deletes an external subtitle file.
     * @param {SubtitleApiDeleteSubtitleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubtitleApi
     */
    deleteSubtitle(requestParameters, options) {
        return SubtitleApiFp(this.configuration).deleteSubtitle(requestParameters.itemId, requestParameters.index, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Downloads a remote subtitle.
     * @param {SubtitleApiDownloadRemoteSubtitlesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubtitleApi
     */
    downloadRemoteSubtitles(requestParameters, options) {
        return SubtitleApiFp(this.configuration).downloadRemoteSubtitles(requestParameters.itemId, requestParameters.subtitleId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Gets a fallback font file.
     * @param {SubtitleApiGetFallbackFontRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubtitleApi
     */
    getFallbackFont(requestParameters, options) {
        return SubtitleApiFp(this.configuration).getFallbackFont(requestParameters.name, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Gets a list of available fallback font files.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubtitleApi
     */
    getFallbackFontList(options) {
        return SubtitleApiFp(this.configuration).getFallbackFontList(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Gets the remote subtitles.
     * @param {SubtitleApiGetRemoteSubtitlesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubtitleApi
     */
    getRemoteSubtitles(requestParameters, options) {
        return SubtitleApiFp(this.configuration).getRemoteSubtitles(requestParameters.subtitleId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Gets subtitles in a specified format.
     * @param {SubtitleApiGetSubtitleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubtitleApi
     */
    getSubtitle(requestParameters, options) {
        return SubtitleApiFp(this.configuration).getSubtitle(requestParameters.routeItemId, requestParameters.routeMediaSourceId, requestParameters.routeIndex, requestParameters.routeFormat, requestParameters.itemId, requestParameters.mediaSourceId, requestParameters.index, requestParameters.format, requestParameters.endPositionTicks, requestParameters.copyTimestamps, requestParameters.addVttTimeMap, requestParameters.startPositionTicks, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Gets an HLS subtitle playlist.
     * @param {SubtitleApiGetSubtitlePlaylistRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubtitleApi
     */
    getSubtitlePlaylist(requestParameters, options) {
        return SubtitleApiFp(this.configuration).getSubtitlePlaylist(requestParameters.itemId, requestParameters.index, requestParameters.mediaSourceId, requestParameters.segmentLength, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Gets subtitles in a specified format.
     * @param {SubtitleApiGetSubtitleWithTicksRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubtitleApi
     */
    getSubtitleWithTicks(requestParameters, options) {
        return SubtitleApiFp(this.configuration).getSubtitleWithTicks(requestParameters.routeItemId, requestParameters.routeMediaSourceId, requestParameters.routeIndex, requestParameters.routeStartPositionTicks, requestParameters.routeFormat, requestParameters.itemId, requestParameters.mediaSourceId, requestParameters.index, requestParameters.startPositionTicks, requestParameters.format, requestParameters.endPositionTicks, requestParameters.copyTimestamps, requestParameters.addVttTimeMap, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Search remote subtitles.
     * @param {SubtitleApiSearchRemoteSubtitlesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubtitleApi
     */
    searchRemoteSubtitles(requestParameters, options) {
        return SubtitleApiFp(this.configuration).searchRemoteSubtitles(requestParameters.itemId, requestParameters.language, requestParameters.isPerfectMatch, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Upload an external subtitle file.
     * @param {SubtitleApiUploadSubtitleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubtitleApi
     */
    uploadSubtitle(requestParameters, options) {
        return SubtitleApiFp(this.configuration).uploadSubtitle(requestParameters.itemId, requestParameters.uploadSubtitleDto, options).then((request) => request(this.axios, this.basePath));
    }
}

export { SubtitleApi, SubtitleApiAxiosParamCreator, SubtitleApiFactory, SubtitleApiFp };
